@let entries = rendered();
<div class="activity-log" #list (scroll)="onScroll()">
  @if (entries.length === 0) {
    <div class="empty">{{ 'No activity yet' | translate }}</div>
  } @else {
    @for (entry of entries; track entry.id) {
      <div class="entry">
        <fa-duotone-icon [icon]="entry.icon" class="entry-icon"></fa-duotone-icon>
        <span class="entry-text" [innerHTML]="entry.html"></span>
        <span class="entry-time">{{ entry.time }}</span>
      </div>
    }
  }
</div>
